import DBR from "dynamsoft-javascript-barcode";
DBR.BarcodeReader.engineResourcePath =
  "https://cdn.jsdelivr.net/npm/dynamsoft-javascript-barcode@8.8.7/dist/";
DBR.BarcodeScanner.organizationID = "101029049-1651158310943";
export default DBR;
